import { apiCall } from "@/lib/api"
import type {
  DemoCallListItem,
  DemoCallOptions,
  DemoCallRequest,
  DemoCallResponse,
  DemoCallStatus,
} from "./types"

export const demoCallsApi = {
  getOptions: () =>
    apiCall<DemoCallOptions>({ url: "/demo-call/options", method: "GET" }),

  placeCall: (data: DemoCallRequest) =>
    apiCall<DemoCallResponse>({ url: "/demo-call", method: "POST", data }),

  getStatus: (callId: string) =>
    apiCall<DemoCallStatus>({ url: `/demo-call/${callId}`, method: "GET" }),

  getRecent: (limit = 8) =>
    apiCall<DemoCallListItem[]>({
      url: "/demo-call",
      method: "GET",
      params: { limit },
    }),
}
